module.exports = __webpack_public_path__ + "static/banner-1e330c652d2bb36457541b5ccadbdbe6.png";